














import Vue from "vue";
import * as routes from "@/router/routes";

// Vue Components
import StandardPage from "@/components/PageTemplates/StandardPage.vue";
import SmartLockMainTable from "@/views/App/OneTimeCode/SmartLock/SmartLockMainTable.vue";

// Model
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { FetchInstallationsSmartLockStatusCommand } from "@/model/communication/oneTimeCode/FetchInstallationsSmartLockStatusCommand";
import { FetchInstallationsSmartLockStatusResData } from "@/model/communication/oneTimeCode/FetchInstallationsSmartLockStatusResData";

export default Vue.extend({
    components: {
        StandardPage,
    },
    data() {
        return {
            routes,
            SmartLockMainTable,
            loading: false,
            reqData: null,
            installations: [],
            paginatedTotalItems: 0,
        };
    },
    methods: {
        async sendRequest(request) {
            try {
                this.reqData = request;
                this.loading = true;
                let response: FetchInstallationsSmartLockStatusResData = await new FetchInstallationsSmartLockStatusCommand(request).execute();

                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    this.installations = response.installationsList;
                    this.paginatedTotalItems = response.totalInstallationsCount;
                }
            } catch (e) {
                console.log("Something went wrong sending FetchInstallationsSmartLockStatus request ", e);
            }
            this.loading = false;
        },
    },
});
